import Vue from 'vue';
import qs from 'qs';
import { http } from '@/http';
import Modal, { ModalLinePrimary, ModalLineSecondary } from '@/components/Modal';
import Input from '@/components/Controls/Input';
import Button from '@/components/Controls/Button';
import Checkbox from '@/components/Controls/Checkbox';
import { CmsError } from '@/http/CmsError';
import { Airplane } from './Airplane';
import * as events from '@/metrix/events';
import { AboutWidgetData, AboutData } from './types';
import './AboutWidget.scss';
import { RootElementAttrsHolder } from '@/plugins/RootElementAttrsPlugin';
import {ModalData} from "@/widgets/FeedbackWidget/types";

const defaults: AboutData = {
    head: '',
    text: '',
    image: ''
};

export function createAboutWidget(el: Element) {

    if(el===null) return

    const rootAttrs = new RootElementAttrsHolder(el);

    return new Vue({
        el,
        name: 'AboutWidget',
        rootAttrs,
        data(): AboutWidgetData {
            return {
                head: '',
                text: '',
                image: '',
                active: false,
                aboutData: {} as AboutData,
            };
        },

        methods: {
            show(aboutData?: AboutData) {
                this.aboutData = Object.assign({}, defaults, aboutData || {});
                this.active = true;
            },

            close() {
                this.active = false;
            }
        },

        render(h) {
            return (
                <Modal
                    active={this.active}
                    onClose={() => this.close()}
                    swipeDownMaxDistance={150}
                >
                    <div class="about-container">
                        <div
                            class={{
                                'about-container__body': true
                            }}
                        >
                            <ModalLinePrimary class="text-center">
                                <span domPropsInnerHTML={this.aboutData.head} />
                            </ModalLinePrimary>

                            <ModalLineSecondary class="text-center feedback-container__line-secondary">
                                <span domPropsInnerHTML={this.aboutData.text} />
                            </ModalLineSecondary>


                            <div class="about-container-image" domPropsInnerHTML={this.aboutData.image} />


                        </div>
                    </div>
                </Modal>
            );
        },
    });
}
